import { forwardRef, useEffect, useMemo, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useParams } from "react-router";
import { commonFormFields } from "../../FeuConstants";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { MDBCol, MDBRow } from "mdbreact";
import { Button, Label, TextArea } from "abs-ui-components";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";

const FeuC12FuelBunkered = forwardRef(({ c12FuelTanks, refetchMonitoringData,vesselMstId }, ref) => {

    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);
    const savedValuesRef = useRef({});
    const { dirtyFields } = formState;
    const isC12Dirty = !!(dirtyFields?.c12FuelTanks && Object.keys(dirtyFields.c12FuelTanks).length > 0);

    const c12Fields = useMemo(() => {
        return commonFormFields.reduce((acc, field) => {
            if (field.name === "dataSources") return acc;
            if (field.name === "descriptionOfProcedure") {
                acc.push({
                    ...field,
                    label:
                        "Description of procedure (a brief description of the procedure can be provided if already existing outside the monitoring plan)",
                });
            } else {
                acc.push(field);
            }
            return acc;
        }, []);
    }, []);

    AutoSave(ref, [], async () => {
        const currentValues = getValues("c12FuelTanks");
        const isChanged = Object.keys(currentValues || {}).some(
            key => currentValues[key] !== savedValuesRef.current?.[key]
        );
        if (!isC12Dirty || !isChanged) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c12FuelTanks");
        const payload = {
            ...c12Fields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        if (formValues.id) {
            payload.id = formValues.id;
        }

        const isUpdate = !!formValues.id;
        try {
            const C12FuelBunkered = await callApi({
                method: "POST",
                url: API_ROUTES.C12(vesselMstId),
                data: payload,
            });
            if (C12FuelBunkered?.isSuccess) {
                emitToasterMsg("success", "Table C.1.2", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c12: formValues }));
                savedValuesRef.current = { ...formValues };
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.1.2", C12FuelBunkered?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.1.2", error.errorMessage);
        }
    };

    useEffect(() => {
        if (c12FuelTanks) {
            reset(prev => ({ ...prev, c12FuelTanks: c12FuelTanks }));
        }
    }, [c12FuelTanks, reset]);


    return (
        <div className="b7-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Determining fuel bunkered and fuel in tanks</h6>
                </MDBCol>
            </MDBRow>
            {c12Fields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`c12FuelTanks.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`c12FuelTanks_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="c12_save_btn"
                    disabled={!isC12Dirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>Save</Button>
            </div>
        </div>
    );
})

export default FeuC12FuelBunkered;